import cloudinary from 'cloudinary-core'

const config = {
  "default": {
    "cloudinary_cloud_name": "pbxx-dev"
  },
  "dev-red": {
    "cloudinary_cloud_name": "pbxx-dev"
  },
  "dev-black": {
    "cloudinary_cloud_name": "pbxx-dev"
  },
  "dev-blue": {
    "cloudinary_cloud_name": "pbxx-dev"
  },
  "dev-green": {
    "cloudinary_cloud_name": "pbxx-dev"
  },
  "dev-pink": {
    "cloudinary_cloud_name": "pbxx-dev"
  },
  "dev-white": {
    "cloudinary_cloud_name": "pbxx-dev"
  },
  "dev-pine": {
    "cloudinary_cloud_name": "pbxx-dev"
  },
  "dev-maple": {
    "cloudinary_cloud_name": "pbxx-dev"
  },
  "staging": {
    "cloudinary_cloud_name": "pbxx-staging"
  },
  "staging_new": {
    "cloudinary_cloud_name": "pbxx-staging"
  },
  "production": {
    "cloudinary_cloud_name": "promoboxx"
  }
}

const firebase_project_alias = process.env.VUE_APP_FIREBASE_PROJECT_ALIAS || 'default'
const cloud_name = config[firebase_project_alias].cloudinary_cloud_name
export const cloudinary_configuration_options = { "cloud_name": cloud_name, "secure": true, "cdn_subdomain": true }
export const cl = cloudinary.Cloudinary.new(cloudinary_configuration_options)
